import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { WpSlaTrendService } from "./service/wp-sla-trend.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "widget-wp-sla-trend",
  templateUrl: "./widget-wp-sla-trend.component.html",
  styleUrls: ["./widget-wp-sla-trend.component.scss"],
  providers: [WpSlaTrendService]
})
export class WidgetWpSlaTrendComponent implements OnInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  widgetId = 20;

  highcharts: typeof Highcharts = Highcharts;
  loadingChart = true;
  chartOptions = HSET.chartData;
  errorMessage = "";
  mockChart = null;

  constructor(
    private translateService: TranslateService,
    private dataService: WpSlaTrendService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getSLAtrendData();
    }
  }

  ngOnInit() {
    this.translateService
      .get("WAREHOUSE.WAREHOUSE_SLA_TREND")
      .pipe(takeUntil(this.unsubscribe)).subscribe(text => {
        this.OPTIONS.title = this.OPTIONS.title || text;
      });
    this.broadcaster.listen("PAGE_WIDGET_DATA")
      .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.setWidgetData();
      });

    this.getSLAtrendData();
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      this.chartOptions.series[2].data = [];
      for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }

  getSLAtrendData() {
    const params = {};
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;
    this.dataService.getSLAtrendData(this.OPTIONS.api, this.FILTERS).pipe(takeUntil(this.unsubscribe)).subscribe(
      chart => {
        if (chart.labels.length) {
          this.loadingChart = false;

          this.chartOptions = this.dataService.createChart(chart, this.OPTIONS);
          this.setWidgetData();
        } else {
          this.loadingChart = true;

          this.errorMessage = "ERROR_MSG.NO_DATA";
          this.mockChart = HSET.chartData;
        }
      },
      error => {
        this.loadingChart = true;

        this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
        this.mockChart = HSET.chartData;
      }
    );
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
